module.exports = __webpack_public_path__ + "img/1564574743.41f4d41b.jpg";